// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IFundsHistoryItemDto
 */
export interface IFundsHistoryItemDto {
    /**
     * 
     * @type {number}
     * @memberof IFundsHistoryItemDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IFundsHistoryItemDto
     */
    amount?: number;
    /**
     * 
     * @type {Date}
     * @memberof IFundsHistoryItemDto
     */
    activity_date?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof IFundsHistoryItemDto
     */
    matched?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IFundsHistoryItemDto
     */
    description?: string;
}

/**
 * Check if a given object implements the IFundsHistoryItemDto interface.
 */
export function instanceOfIFundsHistoryItemDto(value: object): value is IFundsHistoryItemDto {
    return true;
}

export function IFundsHistoryItemDtoFromJSON(json: any): IFundsHistoryItemDto {
    return IFundsHistoryItemDtoFromJSONTyped(json, false);
}

export function IFundsHistoryItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IFundsHistoryItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'activity_date': json['activity_date'] == null ? undefined : (new Date(json['activity_date'])),
        'matched': json['matched'] == null ? undefined : json['matched'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function IFundsHistoryItemDtoToJSON(json: any): IFundsHistoryItemDto {
    return IFundsHistoryItemDtoToJSONTyped(json, false);
}

export function IFundsHistoryItemDtoToJSONTyped(value?: IFundsHistoryItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'amount': value['amount'],
        'activity_date': value['activity_date'] == null ? undefined : ((value['activity_date']).toISOString()),
        'matched': value['matched'],
        'description': value['description'],
    };
}

